import { Component } from "react";

import { EditorSyncFiles } from "../EditorSync";

interface Props {
  src: string;
  files: EditorSyncFiles;
}

export class EditorPlayerImage extends Component<Props> {
  override render() {
    return (
      <img
        loading="lazy"
        src={this?.props?.files?.[this.props.src]}
        className="w-100 h-100 w-full h-full"
        style={{
          objectFit: "cover",
          objectPosition: "center",
        }}
      />
    );
  }
}

export default EditorPlayerImage;
